// extracted by mini-css-extract-plugin
export default {"box":"IconBox_box__yYHav","md":"IconBox_md__wEdsI","lg":"IconBox_lg__NoV+h"};